<template>
  <div>
    <a class="create-event" data-target="#createEventModal" data-toggle="modal" ref="mydetailTab" @click="resetForms">
      <img src="../../../../assets/Svg/add.svg" alt="add" />
      Add Event
    </a>

    <div class="modal fade" id="createEventModal" tabindex="-1" role="dialog" ref="topSection"
      aria-labelledby="exampleModalLabel">
      <div class="modal-dialog product-cart-modal" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-left-wrapper">
              <div class="left-content">
                <div class="modal-header p-0">
                  <span class="modal-title" id="exampleModalLabel">Create Event</span>
                  <button type="button" class="close-modal d-block d-md-none" data-dismiss="modal" aria-label="Close"
                    ref="closeEventModal" @click="resetForm">
                    <img src="../../../../assets/Svg/close.svg" alt="" />
                  </button>
                </div>
                <div class="d-flex align-items-start flex-wrap flex-md-nowrap" style="gap: 16px;">
                  <div class="event-image">
                    <div class="team-image-create event-image-create">
                      <img v-if="this.eventAvatar.length == 0" src="../../../../assets/Svg/event-upload.svg"
                        alt="event_image" class="default-image" />

                      <div class="new-event-image" v-else-if="this.eventAvatar.length > 0">
                        <clipper-basic :src="this.rawData" preview="preview" :border="4" :outline="0" :corner="false"
                          :ratio="1" :wrap-ratio="1" :init-width="50" :init-height="50" ref="clipper"></clipper-basic>
                      </div>
                      <div class="edit-icon-wrapper" @click="openinput()">
                        <img src="../../../../assets/Svg/team/team-options/edit-2.svg" alt="edit" />
                      </div>
                    </div>
                    <!-- <div class="preview-image">
                    <div v-if="this.eventAvatar.length > 0">
                      <clipper-preview name="preview"></clipper-preview>
                    </div>
                    <div
                      v-else-if="this.eventAvatar.length == 0"
                      class="no-image-wrapper"
                    >
                      <div slot="placeholder">No image</div>
                    </div>
                  </div> -->
                  </div>
                  <div class="event-detail">
                    <div class="container-fluid no-pdd">
                      <div class="row">
                        <div class="col-12" v-if="
                          selectedRoomTeam.sportType == 'Softball (Soft Pitch)' ||
                          selectedRoomTeam.sportType == 'Softball (Fast Pitch)' ||
                          selectedRoomTeam.sportType == 'Softball'
                        ">
                          <div class="form-group">
                            <input type="text" class="form-control" id="createEventName" v-model="eventName"
                              @keyup="errorNull('eventName')" trim required maxlength="100" :class="{
                                'is-invalid': $v.eventName.$error,
                                'is-valid': !$v.eventName.$invalid,
                              }" autocomplete="off" spellcheck="false" />
                            <span v-if="!$v.eventName.required" class="invalid-tooltip">
                              Event name is required
                            </span>
                            <span class="placeholder">Event Name</span>
                          </div>
                        </div>
                        <div class="col-12" v-else>
                          <div class="form-group">
                            <input type="text" class="form-control" id="createEventName" v-model="eventName"
                              @keyup="errorNull('eventName')" trim required maxlength="100" :class="{
                                'is-invalid': $v.eventName.$error,
                                'is-valid': !$v.eventName.$invalid,
                              }" autocomplete="off" spellcheck="false" />
                            <span v-if="!$v.eventName.required" class="invalid-tooltip">
                              Event name is required
                            </span>
                            <span class="placeholder">Event Name</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6">
                          <div class="form-group" :class="{ filled: startDate }">
                            <date-picker :open="open" @close="open = false" :editable="false" :clearable="false"
                              @click.native="open = true" v-model="startDate" valueType="format" format="MMM DD, YYYY"
                              @change="checkdate" :class="{
                                'is-invalid': $v.startDate.$error,
                                'is-valid': !$v.startDate.$invalid,
                              }">
                              <i slot="icon-calendar" class="cursor-pointer">
                                <img src="../../../../assets/Svg/calendar.svg" />
                              </i>
                            </date-picker>
                            <span v-if="!$v.startDate.required" class="invalid-tooltip">
                              Start date is required
                            </span>
                            <span class="placeholder">Start Date</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 pl-lg-0 startTime">
                          <div class="form-group" :class="{ filled: startTime }">
                            <span class="event-error" v-if="timeError != ''">
                              Event Time is Invalid.
                            </span>
                            <div class="input-group time" id="startTimeCheck" data-target-input="nearest">
                              <vue-timepicker id="startTime" class="time-input" required="required" v-model="startTime"
                                @change="checkTime" format="hh:mm A" :disabled="allDay"
                                hide-clear-button data-target-input="nearest" @open="dropdownState = 'opened'"
                                @close="dropdownState = 'closed'" :class="{
                                  'is-invalid': $v.startTime.$error,
                                  'is-valid': !$v.startTime.$invalid,
                                }">
                                <template v-slot:icon>
                                  <img src="../../../../assets/Svg/clock.svg" />
                                </template>
                              </vue-timepicker>
                              <span v-if="!$v.startTime.required" class="invalid-tooltip">
                                Start time is required
                              </span>
                            </div>
                            <span class="placeholder">Start Time</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 mt-3 mt-lg-0">
                          <div class="form-group" :class="{ filled: endDate }">
                            <span class="event-error" v-if="endDateErrorGreater != ''">
                              End date should be greater than start date.
                            </span>
                            <date-picker :open="openEnd" @close="openEnd = false" :editable="false" :clearable="false"
                              @click.native="openEnd = true" v-model="endDate" valueType="format" format="MMM DD, YYYY"
                              @change="checkdate" :class="{
                                'is-invalid': $v.endDate.$error,
                                'is-valid': !$v.endDate.$invalid,
                              }">
                              <i slot="icon-calendar" class="cursor-pointer">
                                <img src="../../../../assets/Svg/calendar.svg" />
                              </i>
                            </date-picker>
                            <span v-if="!$v.endDate.required" class="invalid-tooltip">
                              End date is required
                            </span>
                            <span class="placeholder">End Date</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 pl-lg-0 endTime">
                          <div class="form-group" :class="{ filled: endTime }">
                            <div class="input-group time" id="endTimeCheck" data-target-input="nearest">
                              <vue-timepicker id="endTime" class="time-input" required="required" v-model="endTime"
                                :disabled="allDay" v-on:change="checkTime" format="hh:mm A"
                                hide-clear-button @open="dropdownState = 'opened'" @close="dropdownState = 'closed'"
                                :class="{
                                  'is-invalid': $v.endTime.$error,
                                  'is-valid': !$v.endTime.$invalid,
                                }">
                                <template v-slot:icon>
                                  <img src="../../../../assets/Svg/clock.svg" />
                                </template>
                              </vue-timepicker>
                              <span v-if="!$v.endTime.required" class="invalid-tooltip">
                                End time is required
                              </span>
                            </div>
                            <span class="placeholder">End Time</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 mt-3 mt-lg-0">
                          <div class="form-group">
                            <select class="form-control" id="eventType" v-model="eventType" @change="errorNull" :class="{
                              filled: eventType,
                              'is-invalid': $v.eventType.$error,
                              'is-valid': !$v.eventType.$invalid,
                            }">
                              <option v-for="option in filteredEventTypeOptions" :value="option.value"
                                :key="option.value">
                                {{ option.label }}
                              </option>
                            </select>
                            <span v-if="!$v.eventType.required" class="invalid-tooltip">
                              Event type is required
                            </span>
                            <span class="placeholder">Event Type</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 pl-lg-0 mb-3 d-flex align-items-center justify-content-between">
                          <label class="pr-lg-2 mb-0">All Day</label>
                          <toggle-button class="toogle m-0" v-model="allDay" :value="false" :sync="true" :width="34"
                            ref="toggleBtn" />
                        </div>

                        <div class="col-12 col-lg-6">
                          <div class="form-group">
                            <select class="form-control" id="eventType" v-model="time_zone" @change="onTimeZoneChange"
                              :class="{
                                filled: time_zone,
                                'is-invalid': $v.time_zone.$error,
                                'is-valid': !$v.time_zone.$invalid,
                              }">
                              <option :value="country.gmt + ' ' + country.name" v-for="country in timeZoneList"
                                :key="country.name">
                                {{ country.gmt }} {{ country.name }}
                              </option>
                            </select>
                            <span v-if="!$v.time_zone.required" class="invalid-tooltip">
                              Time zone is required
                            </span>
                            <span class="placeholder">Timezone</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 mb-3 pl-lg-0" v-if="
                          selectedRoomTeam.sportType == 'Softball (Soft Pitch)' ||
                          selectedRoomTeam.sportType == 'Softball (Fast Pitch)' ||
                          selectedRoomTeam.sportType == 'Softball'
                        ">
                          <div class="position-relative">
                            <multiselect v-model="association" id="ajaxsingle" label="association_name" track-by="id"
                              placeholder="Type to search association" open-direction="bottom"
                              :options="associationsAdd" :searchable="true" :loading="isLoading"
                              :internal-search="false" :clear-on-select="false" :close-on-select="true"
                              :options-limit="300" :show-no-results="false" :hide-selected="true"
                              @search-change="asyncFind" @change="errorNull" :class="{
                                'is-invalid': $v.association.$error,
                                'is-valid': !$v.association.$invalid,
                              }">
                              <template slot="tag" slot-scope="{ option, remove }">
                                <span class="custom__tag">&nbsp;<span> {{ option.association_name }}</span><span
                                    class="custom__remove" v-on:click="remove(option)">❌</span></span></template>
                              <template slot="clear" slot-scope="props">
                                <div class="multiselect__clear" v-if="association.length"
                                  @mousedown.prevent.stop="clearAll(props.search)"></div>
                              </template><span slot="noResult">Oops! No Association found. Consider changing
                                the search
                                query.</span>
                              <span slot="noOptions"> No Association found </span>
                              <template slot="option" slot-scope="{ option }">
                                <div class="option__desc">
                                  <span> {{ option.association_name }}</span>
                                </div>
                              </template>
                            </multiselect>
                            <span v-if="!$v.association.required" class="invalid-tooltip">
                              Association is required
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>

                    <input type="file" class="d-none" id="vue-file-new" v-on:change="addEventAvatar"
                      accept="image/png, image/jpeg" />
                  </div>
                </div>

                <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                  <li class="nav-item mb-2">
                    <span>Event Notes</span>
                  </li>
                </ul>

                <div class="tab-content mt-3" id="myTabContent">
                  <div class="tab-pane fade show active" id="noteTab" role="tabpanel">
                    <div class="form-group">
                      <textarea type="text" class="form-control" id="note" rows="15" v-model="note"
                        @keyup="errorNull"></textarea>
                    </div>
                  </div>
                </div>

              </div>

              <div class="right-content container-fluid">
                <div>
                  <button type="button" class="close-modal d-none d-md-block w-100 text-right pb-2" data-dismiss="modal"
                    aria-label="Close" ref="closeEventModal" @click="resetForm">
                    <img src="../../../../assets/Svg/close.svg" alt="" />
                  </button>
                  <ul class="event-menu-list">
                    <li class="list-item" v-bind:class="[openTabEvent == 1 ? 'active' : '']" @click="InPerson">
                      <img v-if="openTabEvent == 1" src="../../../../assets/images/inperson-blue.png" />
                      <img v-else src="../../../../assets/images/inperson-grey.png" />
                      InPerson
                    </li>
                    <li class="list-item" v-bind:class="[openTabEvent == 2 ? 'active' : '']" @click="onlineContent">
                      <img v-if="openTabEvent == 2" src="../../../../assets/images/online-blue.png" />
                      <img v-else src="../../../../assets/images/online-grey.png" />
                      Online
                    </li>
                  </ul>
                  <div class="row no-gutters" v-if="openTabEvent == 1">
                    <div class="col-12 p-0">
                      <div class="form-group">
                        <gmap-autocomplete :value="location" placeholder="Enter an address, zipcode, or location"
                          @place_changed="setPlace" ref="autocompleteRef">
                        </gmap-autocomplete>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <google-map :center="marker.position" :zoom="18" map-style-id="roadmap" :options="mapOptions"
                        style="width: 100%; height: 40vmin; margin-bottom: 20px" ref="mapRef" id="map"
                        @click="handleMapClick">
                        <google-maps-marker :position="marker.position" :clickable="true" :draggable="true"
                          @drag="handleThrottledMarkerDrag" @click="panToMarker"></google-maps-marker>
                      </google-map>
                      <div class="form-group" :class="{ filled: street }">
                        <input type="text" class="form-control" id="street" v-model="street" @keyup="errorNull" required
                          :class="{
                            'is-invalid': $v.street.$error,
                            'is-valid': !$v.street.$invalid,
                          }" />
                        <span v-if="!$v.street.required" class="invalid-tooltip">
                          Street address is required
                        </span>
                        <span class="placeholder">Street Address</span>
                      </div>
                    </div>
                  </div>
                  <div class="row no-gutters" v-if="openTabEvent == 1">
                    <div class="col-12 col-md-4 pr-md-2">
                      <div class="form-group" :class="{ filled: city }">
                        <input type="text" class="form-control" id="city" v-model="city" @keyup="errorNull" required
                          :class="{
                            'is-invalid': $v.city.$error,
                            'is-valid': !$v.city.$invalid,
                          }" />
                        <span v-if="!$v.city.required" class="invalid-tooltip">
                          City is required
                        </span>
                        <span class="placeholder">City</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 px-md-0">
                      <div class="form-group" :class="{ filled: state }">
                        <input type="text" class="form-control" id="state" v-model="state" @keyup="errorNull" required
                          :class="{
                            'is-invalid': $v.state.$error,
                            'is-valid': !$v.state.$invalid,
                          }" />
                        <span v-if="!$v.state.required" class="invalid-tooltip">
                          State is required
                        </span>
                        <span class="placeholder">State</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 pl-md-2">
                      <div class="form-group" :class="{ filled: zipCode }">
                        <input type="number" class="form-control" id="zipCode" v-model="zipCode" @keyup="errorNull"
                          required :class="{
                            'is-invalid': $v.zipCode.$error,
                            'is-valid': !$v.zipCode.$invalid,
                          }" />
                        <span v-if="!$v.zipCode.required" class="invalid-tooltip">
                          Zipcode is required
                        </span>
                        <span class="placeholder">Zip Code</span>
                      </div>
                    </div>
                  </div>
                  <div class="row no-gutters" v-if="openTabEvent == 2">
                    <div class="col-12 p-0">
                      <div class="form-group" :class="{ filled: medium }">
                        <select class="form-control" id="medium" v-model="medium" @change="errorNull" :class="{
                          'is-invalid': $v.medium.$error,
                          'is-valid': !$v.medium.$invalid,
                        }">
                          <option v-for="option in mediumOptions" :key="option.id" :value="option.id">
                            {{ option.name }}
                          </option>
                        </select>
                        <span v-if="!$v.medium.required" class="invalid-tooltip">
                          Medium is required
                        </span>
                        <span class="placeholder">Medium</span>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <div class="form-group" :class="{ filled: Url }">
                        <input type="text" class="form-control" id="Url" v-model="Url" @keyup="$v.Url.$touch()"
                          @input="$v.Url.$touch()" required :class="{
                            'is-invalid': $v.Url.$error,
                            'is-valid': !$v.Url.$invalid && $v.Url.$model
                          }" />
                        <span v-if="Url && !$v.Url.urlValidator" class="invalid-tooltip">
                          URL is invalid
                        </span>
                        <span v-if="!$v.Url.required" class="invalid-tooltip">
                          URL is required
                        </span>
                        <span class="placeholder">URL</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="event-btns-wrapper">
                  <button type="button" class="btn btn-primary w-100" v-on:click="createEvent(0)"
                    :disabled="isLoadingArray[0]">
                    <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
                    <span v-else>
                      <img src="../../../../assets/Svg/save.svg" alt="save">
                      Save
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  required,
  maxLength,
} from "vuelidate/lib/validators";
import VueTimepicker from "vue2-timepicker";
import axios from "axios";
import * as firestoreService from "../../../../database/firestore";
import { parseTimestamp } from "../../../../utils/dates";
import $ from "jquery";
import Multiselect from "vue-multiselect";
let usTime = require("../../../../assets/js/usTimeZone");
import _ from 'lodash';
import { clipperBasic } from "vuejs-clipper";
let eventType = require("../../../../assets/js/eventType");

import { EventBus } from "@/eventBus";

const urlValidator = (value) => {
  if (!value) return true; // Let 'required' handle empty fields

  const regx = new RegExp(
    "^" +
    "(?:(?:https?|http)://)?" +
    "(?:\\S+(?::\\S*)?@)?" +
    "(?:" +
    "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
    "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
    "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
    "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
    "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
    "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
    "|" +
    "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
    "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
    "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
    ")" +
    "(?::\\d{2,5})?" +
    "(?:/\\S*)?" +
    "$", "i"
  );

  return regx.test(value);
};

export default {
  name: "CreateEventDetailModal",
  validations() {
    const requiresAssociation =
      this.selectedRoomTeam?.sportType === 'Softball (Soft Pitch)' ||
      this.selectedRoomTeam?.sportType === 'Softball (Fast Pitch)' ||
      this.selectedRoomTeam?.sportType === 'Softball';

    return this.checkedOnline
      ? {
        eventName: { required, maxLength: maxLength(100) },
        startDate: { required },
        endDate: { required },
        startTime: { required },
        endTime: { required },
        eventType: { required },
        time_zone: { required },
        association: requiresAssociation ? { required } : {},
        street: {},
        city: {},
        state: {},
        zipCode: {},
        medium: { required },
        Url: { required, urlValidator }
      }
      : {
        eventName: { required, maxLength: maxLength(100) },
        startDate: { required },
        endDate: { required },
        startTime: { required },
        endTime: { required },
        eventType: { required },
        time_zone: { required },
        association: requiresAssociation ? { required } : {},
        street: { required },
        city: { required },
        state: { required },
        zipCode: { required },
        medium: {},
        Url: {}
      };
  },
  data() {
    return {
      open: false,
      openEnd: false,
      userName: localStorage.getItem("userName"),
      isDisabledEvent: false,
      showLoaderEvent: 0,
      eventName: null,
      eventType: "",
      association: "",
      location: null,
      exactEndTime: "11:00 AM",
      exactStartTime: "10:00 AM",
      exactStartDate: "",
      exactEndDate: "",
      startDate: "",
      endDate: "",
      startTime: "10:00 AM",
      endTime: "11:00 AM",
      startTime24Hour: "",
      endTime24Hour: "",
      city: "",
      state: "",
      zipCode: "",
      street: "",
      country: "",
      lat: "",
      lng: "",
      note: "",
      allDay: false,
      rawData: "",
      eventAvatar: [],
      eventFinalAvatar: "",
      options: [],
      eventTypeOptions: eventType,
      mediumOptions: [],
      marker: { position: { lat: 10, lng: 10 } },
      markers: [],
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: false,
        gestureHandling: 'cooperative', // allows zooming only with Ctrl + wheel on desktop
        disableDoubleClickZoom: true, // disables zoom on double-click
      },
      startDateError: "",
      endDateError: "",
      endDateErrorGreater: "",
      exactStartDateformat: "",
      exactEndDateformat: "",
      timeError: "",
      currentPlace: null,
      onlineStatus: false,
      checkedOnline: false,
      Url: "",
      medium: "",
      isValid: true,
      associationsAdd: [],
      isLoading: false,
      regex: /^(http|https):\/\/[w\d]+\.[\w](\/[\w\d]+)?$/,
      firstFormValid: true,
      Storage_URL: this.$googleMapApi,
      description: "Singapore",
      latLng: {},
      timeZoneList: usTime,
      time_zone: "",
      deviceTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      openTabEvent: 1,
      isLoadingArray: [],
      userInteracted: false,
    };
  },
  components: {
    Multiselect,
    clipperBasic,
    // clipperPreview,
    VueTimepicker,
  },
  computed: {
    filteredEventTypeOptions() {
      return this.eventTypeOptions.filter(option => option.status === 1);
    },
    ...mapGetters("auth", ["user"]),
    formattedDeviceTimeZone() {
      const gmtOffset = this.getDynamicGmtOffset(this.deviceTimeZone);
      const normalizedTimeZone = this.getNormalizedDeviceTimeZone(this.deviceTimeZone);
      return gmtOffset ? `${gmtOffset} ${normalizedTimeZone}` : this.deviceTimeZone;
    }
  },
  watch: {
    time_zone() {
      if (this.userInteracted) {
        return;
      }
      this.setDefaultTimeZone();
    },
    city(newValue) {
      this.city = newValue;
      this.errorNull();
    },
    state(newValue) {
      this.state = newValue;
      this.errorNull();
    },
    street(newValue) {
      this.street = newValue;
      this.errorNull();
    },
    zipCode(newValue) {
      this.zipCode = newValue;
      this.errorNull();
    },
  },
  props: {
    selectedRoomTeam: {
      type: Object,
    },
    currentUserId: {
      type: String,
    },
    currentIsAdmin: {
      type: String,
    },
  },
  methods: {
    onTimeZoneChange() {
      this.userInteracted = true;
      this.errorNull();
    },
    // Normalize device time zone to a more familiar name if needed
    getNormalizedDeviceTimeZone(deviceTimeZone) {
      if (deviceTimeZone === "Pacific/Honolulu") {
        return "Hawaii Time";
      }
      else if (deviceTimeZone === "America/Los_Angeles") {
        return "Pacific Time";
      }
      else if (deviceTimeZone === "America/Anchorage") {
        return "Alaska Time";
      }
      else if (deviceTimeZone === "America/Denver") {
        return "Mountain Time";
      }
      else if (deviceTimeZone === "America/Chicago") {
        return "Central Time";
      }
      else if (deviceTimeZone === "America/New_York") {
        return "Eastern Time";
      }
      return deviceTimeZone;
    },
    getDynamicGmtOffset() {
      const date = new Date();
      const utcOffset = date.getTimezoneOffset(); // Offset in minutes from UTC
      const hoursOffset = Math.floor(Math.abs(utcOffset) / 60);
      const minutesOffset = Math.abs(utcOffset) % 60;

      // Determine the sign for the offset
      const sign = utcOffset < 0 ? '+' : '-';

      // Format the GMT offset
      return `(UTC${sign}${String(hoursOffset).padStart(2, '0')}:${String(minutesOffset).padStart(2, '0')})`;
    },
    setDefaultTimeZone() {
      const match = this.timeZoneList.find(
        (country) => `${country.gmt} ${country.name}` === this.formattedDeviceTimeZone
      );

      if (match) {
        this.$nextTick(() => {
          this.time_zone = `${match.gmt} ${match.name}`;
        });
      } else {
        this.time_zone = ""; // Shows "Time Zone" if no match is found
      }
    },
    // handleClickStart(evt) {
    //   if (evt.target.tagName !== "INPUT") {
    //     this.open = true;
    //   }
    // },
    // handleClickEnd(evt) {
    //   if (evt.target.tagName !== "INPUT") {
    //     this.openEnd = true;
    //   }
    // },
    usePlace() {
      if (this.location) {
        this.markers.push({
          position: {
            lat: this.location.geometry.location.lat(),
            lng: this.location.geometry.location.lng(),
          },
        });
        this.location = null;
      }
    },
    InPerson() {
      this.$v.street.$reset();
      this.$v.city.$reset();
      this.$v.state.$reset();
      this.$v.zipCode.$reset();
      this.$root.$emit("openTabTeamEvent", 1, 0);
      this.medium = "";
      this.Url = "";
      if (this.medium == "" && this.Url == "") {
        this.isDisabledEvent = true;
      } else {
        this.isDisabledEvent = false;
      }
      this.checkTab(1);
    },
    onlineContent() {
      this.$v.medium.$reset();
      this.$v.Url.$reset();
      this.$root.$emit("openTabTeamEvent", 2, 0);
      this.city = "";
      this.state = "";
      this.zipCode = "";
      this.street = "";
      this.checkTab(2);
    },
    resetForm: function () {
      document.getElementById("vue-file-new").value = "";
    },
    handleThrottledMarkerDrag: _.throttle(function (event) {
      this.handleMarkerDrag(event);
    }, 50),
    resetForms: function () {
      this.$v.$reset();
      this.getMedium();
      document.getElementById("vue-file-new").value = "";
      this.exactEndTime = "11:00 AM";
      this.exactStartTime = "10:00 AM";
      this.startTime = "10:00";
      this.endTime = "11:00";
      var element = this.$refs.mydetailTab;
      if (element) {
        element.click();
      }
      this.isDisabledEvent = false;
      this.firstFormValid = true;
      this.showLoaderEvent = 0;
      this.eventName = "";
      this.eventType = "";
      this.association = "";
      this.location = "";
      this.exactEndTime = "11:00 AM";
      this.exactStartTime = "10:00 AM";
      this.exactStartDate = "";
      this.exactEndDate = "";
      this.startDate = "";
      this.endDate = "";
      this.startTime = "10:00";
      this.endTime = "11:00";
      this.city = "";
      this.state = "";
      this.zipCode = "";
      this.street = "";
      this.lan = "";
      this.long = "";
      this.note = "";
      this.allDay = false;
      this.rawData = "";
      this.eventAvatar = [];
      this.eventFinalAvatar = "";
      (this.time_zone = ""), (this.startDateError = "");
      this.endDateError = "";
      this.endDateErrorGreater = "";
      this.timeError = "";

      this.exactStartDateformat = "";
      this.exactEndDateformat = "";
      (this.medium = ""), (this.Url = "");
      this.allDay = false;
    },

    errorNull: function () {
      // this.validatefirstForm();
      if (this.checkedOnline == false) {
        if (
          this.city == "" ||
          this.state == "" ||
          this.zipCode == "" ||
          this.street == "" ||
          this.state == null ||
          this.city == null ||
          this.street == null ||
          this.zipCode == null ||
          this.eventName == "" ||
          this.eventType == "" ||
          // this.association == "" ||
          this.timeError != "" ||
          this.startDate == "" ||
          this.endDate == "" ||
          this.endDateErrorGreater != "" ||
          // this.startTime == "" ||
          // this.endTime == "" ||
          ((this.exactStartTime == "" || this.exactEndTime == "") && this.allDay == false)
        ) {
          this.isDisabledEvent = true;
        } else {
          this.isDisabledEvent = false;
        }
      }
      if (this.checkedOnline == true) {
        if (
          this.medium == "" ||
          this.medium == null ||
          this.Url == "" ||
          this.Url == null ||
          this.isValid == false ||
          this.eventName == "" ||
          this.eventType == "" ||
          // this.association == "" ||
          this.timeError != "" ||
          this.startDate == "" ||
          this.endDate == "" ||
          this.endDateErrorGreater != "" ||
          // this.startTime == "" ||
          // this.endTime == ""
          ((this.exactStartTime == "" || this.exactEndTime == "") && this.allDay == false)
        ) {
          this.isDisabledEvent = true;
        } else {
          this.isDisabledEvent = false;
        }
      }
    },

    // checkTime: function () {
    //   if (this.startTime != "") {
    //     var timeSplit = this.startTime.split(":"),
    //       hours,
    //       minutes,
    //       meridian;
    //     hours = timeSplit[0];
    //     minutes = timeSplit[1];
    //     if (hours > 12) {
    //       meridian = "PM";
    //       hours -= 12;
    //     } else if (hours < 12) {
    //       meridian = "AM";
    //       if (hours == 0) {
    //         hours = 12;
    //       }
    //     } else {
    //       meridian = "PM";
    //     }
    //     this.exactStartTime = hours + ":" + minutes + " " + meridian;
    //   }

    //   if (this.endTime != "") {
    //     var timeSplitend = this.endTime.split(":"),
    //       hoursend,
    //       minutesend,
    //       meridianend;
    //     hoursend = timeSplitend[0];
    //     minutesend = timeSplitend[1];
    //     if (hoursend > 12) {
    //       meridianend = "PM";
    //       hoursend -= 12;
    //     } else if (hoursend < 12) {
    //       meridianend = "AM";
    //       if (hoursend == 0) {
    //         hoursend = 12;
    //       }
    //     } else {
    //       meridianend = "PM";
    //     }
    //     this.exactEndTime = hoursend + ":" + minutesend + " " + meridianend;
    //   }
    //   this.checkTimeDate();
    // },

    checkTime: function () {
      if (this.startTime != "") {
        this.exactStartTime = this.startTime;
        this.startTime24Hour = this.convertTo24Hour(this.startTime); // from 24h to 12h
      }
      if (this.endTime != "") {
        this.exactEndTime = this.endTime; // from 24h to 12h
        this.endTime24Hour = this.convertTo24Hour(this.endTime); // from 24h to 12h
      }
      this.checkTimeDate(); // keep this if you're validating date/time
    },

    convertTo24Hour(time12) {
      let [time, modifier] = time12.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) {
        hours += 12;
      } else if (modifier === "AM" && hours === 12) {
        hours = 0;
      }

      const paddedHours = hours.toString().padStart(2, "0");
      const paddedMinutes = minutes.toString().padStart(2, "0");

      return `${paddedHours}:${paddedMinutes}`;
    },

    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      if (!place) return;
      this.$refs.autocompleteRef.$el.classList.add("custom-dropdown-open");
      this.marker.position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.street = place.formatted_address;
      this.location = place.formatted_address;
      const addressComponents = place.address_components;

      for (const component of addressComponents) {
        const types = component.types;
        if (types.includes("locality")) {
          this.city = component.long_name;
        } else if (types.includes("administrative_area_level_1")) {
          this.state = component.short_name;
        } else if (types.includes("postal_code")) {
          this.zipCode = component.long_name;
        }
      }
      this.panToMarker();
    },
    // Check dates
    // checkdate: function () {
    //   const month = [
    //     "Jan",
    //     "Feb",
    //     "Mar",
    //     "Apr",
    //     "May",
    //     "Jun",
    //     "July",
    //     "Aug",
    //     "Sep",
    //     "Oct",
    //     "Nov",
    //     "Dec",
    //   ];

    //   // Start Date

    //   if (this.startDate.length == 10) {
    //     const startDateArray = this.formatDateForDB(this.startDate).split("-");
    //     var startMonth = startDateArray[1];
    //     var startDay = startDateArray[2];
    //     var startYear = startDateArray[0];

    //     var varDate = startMonth + "-" + startDay + "-" + startYear;
    //     var startDateConvert = new Date(varDate);
    //     this.exactStartDateformat = startDateConvert;
    //     this.exactStartDate = month[startMonth - 1] + " " + startDay + ", " + startYear;
    //   }

    //   // End Date-----
    //   if (this.endDate.length == 10) {
    //     const endDateArray = this.formatDateForDB(this.endDate).split("-");
    //     var endMonth = endDateArray[1];
    //     var endDay = endDateArray[2];
    //     var endYear = endDateArray[0];

    //     var varDatee = endMonth + "-" + endDay + "-" + endYear;
    //     var endDateConvert = new Date(varDatee);
    //     if (endDateConvert < startDateConvert) {
    //       this.endDateError = "";
    //       this.endDateErrorGreater = "on";
    //       this.exactEndDate = "";
    //       this.isDisabledEvent = true;
    //     } else {
    //       this.exactEndDateformat = endDateConvert;
    //       this.endDateError = "";
    //       this.endDateErrorGreater = "";
    //       this.exactEndDate = month[endMonth - 1] + " " + endDay + ", " + endYear;
    //     }
    //   }

    //   this.checkTimeDate();
    // },
    checkdate: function () {
      const month = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      let startDateConvert, endDateConvert;

      // Convert Start Date
      if (this.startDate && this.startDate.length === 12) {  // Format: "Mar 21, 2025"
        const startDateArray = this.startDate.split(" ");
        let startMonth = month.indexOf(startDateArray[0]) + 1; // Convert month to number
        startMonth = startMonth < 10 ? `0${startMonth}` : startMonth; // Add leading zero
        const startDay = startDateArray[1].replace(",", ""); // Remove comma
        const startYear = startDateArray[2];

        const formattedStartDate = `${startMonth}-${startDay}-${startYear}`;
        startDateConvert = new Date(formattedStartDate);
        this.exactStartDateformat = startDateConvert;
        this.exactStartDate = `${month[startMonth - 1]} ${startDay}, ${startYear}`;
      }

      // Convert End Date
      if (this.endDate && this.endDate.length === 12) {  // Format: "Mar 21, 2025"
        const endDateArray = this.endDate.split(" ");
        let endMonth = month.indexOf(endDateArray[0]) + 1; // Convert month to number
        endMonth = endMonth < 10 ? `0${endMonth}` : endMonth; // Add leading zero
        const endDay = endDateArray[1].replace(",", ""); // Remove comma
        const endYear = endDateArray[2];

        const formattedEndDate = `${endMonth}-${endDay}-${endYear}`;
        endDateConvert = new Date(formattedEndDate);

        if (startDateConvert && endDateConvert < startDateConvert) {
          this.endDateError = "";
          this.endDateErrorGreater = "on";
          this.exactEndDate = "";
          this.isDisabledEvent = true;
        } else {
          this.exactEndDateformat = endDateConvert;
          this.endDateError = "";
          this.endDateErrorGreater = "";
          this.exactEndDate = `${month[endMonth - 1]} ${endDay}, ${endYear}`;
        }
      }

      this.checkTimeDate();
    },
    formatDate(date) {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const d = new Date(date);
      const month = monthNames[d.getMonth()];
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();

      return `${month} ${day}, ${year}`;
    },
    formatDateForDB(date) {
      if (!date) return null; // Ensure there's a valid date
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },

    // check timeDate
    checkTimeDate: function () {
      this.startDateError = this.exactStartDate != "" ? "" : "on";
      this.endDateError = this.exactEndDate != "" ? "" : "on";

      if (this.exactStartTime != "" && this.exactStartDate != "") {
        this.errorNull();
      }
    },

    // Upload Image
    openinput: function () {
      document.getElementById("vue-file-new").click();
    },

    addEventAvatar: async function (event) {
  const fileInput = document.getElementById("vue-file-new");
  const file = event.target.files[0];

  const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
  if (!allowedExtensions.exec(file.name)) {
    alert("Please upload file having extensions .jpeg/.jpg/.png/.gif only.");
    fileInput.value = "";
    return false;
  }

  try {
    const resized = await this.resizeImage(file); // Resize first

    this.eventAvatar.push({
      target: resized.blob,
      fileName: file.name,
      link: resized.url,
    });

    this.rawData = resized.url; // use compressed URL in clipper
    this.errorNull();
  } catch (err) {
    console.error("Failed to resize image:", err);
  }
},

resizeImage(file, maxSize = 1000) {
  return new Promise((resolve, reject) => {
    const fileSizeMB = file.size / (1024 * 1024);
    const mimeType = file.type; // Keep original format (e.g., image/png)

    if (fileSizeMB <= 5) {
      const originalUrl = URL.createObjectURL(file);
      return resolve({
        blob: file,
        url: originalUrl
      });
    }

    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ratio = Math.min(maxSize / img.width, maxSize / img.height, 1);
      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob((blob) => {
        const resizedURL = URL.createObjectURL(blob);
        resolve({
          blob: blob,
          url: resizedURL
        });
      }, mimeType, 0.9); // Keep original type (image/png, image/jpeg, etc.)
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
},

    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },

    // Create Event
    async createEvent(index) {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;

      if (this.$v.$invalid) {
        return
      }
      this.$set(this.isLoadingArray, index, true);
      this.isDisabledEvent = true;

      let formData = new FormData();

      // Handle event avatar upload - get cropped image if available
      if (this.eventAvatar.length > 0) {
        if (this.$refs.clipper) {
          try {
            // Get cropped canvas from clipper
            const canvas = this.$refs.clipper.clip();
            // Convert canvas to blob
            const blob = await new Promise((resolve) => {
              canvas.toBlob((blob) => {
                resolve(blob);
              }, 'image/png');
            });

            // Create a file from the blob
            const croppedFile = new File([blob], this.eventAvatar[0].fileName || 'cropped-image.png', {
              type: 'image/png'
            });

            formData.append("avatar[0]", croppedFile);
          } catch (error) {
            console.error("Error processing cropped image:", error);
            // Fallback to original image if cropping fails
            this.eventAvatar.forEach((value, index) => {
              formData.append("avatar[" + index + "]", value.target);
            });
          }
        } else {
          // Use original image if clipper isn't available
          this.eventAvatar.forEach((value, index) => {
            formData.append("avatar[" + index + "]", value.target);
          });
        }
      };

      // Convert user array to string
      let userCIDArray = [];

      const fetchPromises = this.selectedRoomTeam.users.map(async (user) => {
        if (typeof user === "string") {
          // Case 1: If user is a string (fetch from Firestore)
          try {
            const userData = await firestoreService.getUser(user);

            if (userData && userData.c_id) {
              userCIDArray.push(userData.c_id); // Store c_id
            }
          } catch (error) {
            console.error(`Error fetching user with ID ${user}:`, error);
          }
        } else if (typeof user === "object" && user !== null) {
          // Case 2: If user is an object, push _id directly
          if (user._id) {
            userCIDArray.push(user.c_id);
          }
        }
      });

      // Wait for all Firestore fetches to complete before proceeding
      await Promise.all(fetchPromises);

      // Convert array to string
      const userString = userCIDArray.join(", ");


      this.startTime = this.allDay == true ? "00:00" : this.startTime;
      this.exactStartTime = this.allDay == true ? "12:00 AM" : this.exactStartTime;
      this.endTime = this.allDay == true ? "24:00" : this.endTime;
      this.exactEndTime = this.allDay == true ? "12:00 PM" : this.exactEndTime;
      formData.append("eventName", this.eventName ? this.eventName : "");

      formData.append("users", userString);

      formData.append("team_id", this.selectedRoomTeam.roomId ? this.selectedRoomTeam.roomId : this.selectedRoomTeam.id);
      formData.append("eventType", this.eventType);
      formData.append("association", this.association.id ? this.association.id : "");
      formData.append("startDateForField", this.formatDateForDB(this.startDate));
      formData.append("endDateForField", this.formatDateForDB(this.endDate));
      formData.append("startDate", this.exactStartDateformat);
      formData.append("endDate", this.exactEndDateformat);
      formData.append("startTime", this.startTime24Hour);
      formData.append("endTime", this.endTime24Hour);
      formData.append("exactStartDate", this.exactStartDate);
      formData.append("exactEndDate", this.exactEndDate);
      formData.append("exactStartTime", this.exactStartTime);
      formData.append("exactEndTime", this.exactEndTime);
      formData.append("allDay", this.allDay);
      formData.append("note", this.note ? this.note : "");
      formData.append("time_zone", this.time_zone ? this.time_zone : "");

      formData.append("createdByName", this.userName);
      if (this.checkedOnline == false) {
        formData.append("lan", this.marker.position.lat);
        formData.append("long", this.marker.position.lng);
        formData.append("address", this.street ? this.street : "");
        formData.append("location", this.location ? this.location : "");
        formData.append("city", this.city ? this.city : "");
        formData.append("state", this.state ? this.state : "");
        formData.append("zipCode", this.zipCode ? this.zipCode : "");
        formData.append("medium_id", "");
        formData.append("Url", "");
        formData.append("online", this.onlineStatus);
      } else if (this.checkedOnline == true) {
        formData.append("medium_id", this.medium ? this.medium : "");
        formData.append("Url", this.Url ? this.Url : "");
        formData.append("online", this.onlineStatus);
        formData.append("location", "");
        formData.append("city", "");
        formData.append("state", "");
      }
      formData.append("createdByDate", parseTimestamp(new Date(), "DD/MM/YY"));
      await axios
        .post(process.env.VUE_APP_API_URL + "event/create", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          firestoreService.updateRoom(this.selectedRoomTeam.roomId ? this.selectedRoomTeam.roomId : this.selectedRoomTeam.id, {
            eventCount: this.selectedRoomTeam.eventCount + 1,
            // lastUpdated: new Date(),
          });

          this.$root.$emit("ChatSettings", 0);
          this.$root.$emit("fetchEvents");
          this.$root.$emit("fetchEventsonMyEventsPage");
          var elem = this.$refs.closeEventModal;
          elem.click();
          this.$set(this.isLoadingArray, index, false);
        });
    },
    asyncFind(searchQuery) {
      this.isLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}getAssociation?search=${searchQuery ? searchQuery : ""
          }`,
          this.details,
          {}
        )
        .then((response) => {
          this.associationsAdd = response.data.data.association;
          this.isLoading = false;
        });
    },

    getMedium() {
      axios.get(`${process.env.VUE_APP_API_URL}getMedium`).then((response) => {
        if (response.data.statusCode == 200) {
          this.mediumOptions = response.data.data.medium;
        } else {
          this.errorMessage = response.data.message;
        }
      });
    },
    //detects location from browser
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.panToMarker();
      });
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === "OK") {
          if (results[1]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "locality") {
                    window.test.city = results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route" ||
                results[i]?.types[0] == "neighborhood"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] == "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "postal_code") {
                    window.test.zipCode = results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
      this.errorNull();
    },
    getCity(addressArray) {
      let city = "";
      for (let i = 0; i < addressArray.length; i++) {
        // eslint-disable-next-line
        if (addressArray[i].types[0] && "locality" == addressArray[i].types[0]) {
          city = addressArray[i].long_name;
          return city;
        }
      }
    },
    //Moves the map view port to marker
    panToMarker() {
      if (this.marker?.position) {
        this.$refs.mapRef?.panTo(this.marker.position);
      }
    },
    //Moves the marker to click position on the map
    handleMapClick(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === "OK") {
          if (results[0]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "locality") {
                    window.test.city = results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] == "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "postal_code") {
                    window.test.zipCode = results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
      this.errorNull();
    },
    showLocation() {
      var elem = this.$refs.locationTabGet;
      elem.click();
      this.$refs.topSection.scrollTo(0, 0);
      this.geolocate();
    },
    validatefirstForm() {
      // if (
      //   this.eventName == "" ||
      //   this.exactStartDate == "" ||
      //   this.exactEndDate == "" ||
      //   this.eventType == "" ||
      //   this.association == "" ||
      //   this.timeError != ""
      // ) {
      //   this.firstFormValid = true;
      //   this.isDisabledEvent = true;
      // } else {
      if (
        (this.exactStartTime == "" || this.exactEndTime == "") &&
        this.allDay == false
      ) {
        // this.firstFormValid = true;
        this.isDisabledEvent = true;
      } else {
        this.firstFormValid = false;
      }
      // }
    },
    checkTab(check) {
      if (check == 1) {
        this.onlineStatus = false;
      } else {
        this.onlineStatus = true;
      }
      if (this.onlineStatus == true) {
        this.checkedOnline = true;
      } else {
        this.checkedOnline = false;
        this.Url = "";
      }
    },
    change(e) {
      const url = e.target.value;
      this.isURLValid(url);
    },
    isURLValid(inputUrl) {
      var regx = new RegExp(
        "^" +
        // optional protocol identifier
        "(?:(?:https?|http)://)?" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:" +
        // IP address exclusion
        // private & local networks
        "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
        "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
        "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
        // IP address dotted notation octets
        // excludes loopback network 0.0.0.0
        // excludes reserved space >= 224.0.0.0
        // excludes network & broacast addresses
        // (first & last IP address of each class)
        "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
        "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
        "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
        // host name
        "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
        // domain name
        "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
        // TLD identifier
        "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:/\\S*)?" +
        "$",
        "i"
      );
      this.isValid = regx.test(inputUrl);
    },
    showHideTimeDiv() {
      if (this.allDay == true) {
        $(".startTime").hide();
        $(".endTime").hide();
        // this.allDay = true;
        this.exactStartTime = "";
        this.startTime = "";
        this.endTime = "";
        this.exactEndTime = "";
        // this.isDisabledEvent = false;
      } else if (this.allDay == false) {
        $(".startTime").show();
        $(".endTime").show();
        this.exactStartTime = "10:00 AM";
        this.startTime = "10:00";
        this.endTime = "11:00";
        this.exactEndTime = "11:00 AM";
      }
      // this.validatefirstForm();
    },

    showPro() {
      this.$router.push({ name: "GoPro" });
    },
  },
  mounted() {
    EventBus.$on("reset-forms", this.resetForms);
    this.setDefaultTimeZone();
    this.asyncFind();
    this.geolocate();
    this.$root.$on("openTabTeamEvent", (id) => {
      this.openTabEvent = id;
    });
  },
};
</script>
